import { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import { ModalContext } from '../../../../../store/modal-context';

import RequestCode from './RequestCode';
import RequestDetails from './RequestDetails';
import CompleteRequest from './CompleteRequest';

const ResetPassword = () => {
  const {t: translate } = useTranslation();
  let initState = 'waiting';

  const queryParams = new URLSearchParams(window.location.search);
  const forcedReset = queryParams.get('forced');

  if (forcedReset === 'true') {
    initState = 'details';
  }

  const { modal, handleModal } = useContext(ModalContext);
  //3 states - waiting, details, complete
  const [resetState, setResetState] = useState(initState);
  const [email, setEmail] = useState('');

  const updateState = (value) => {
    setResetState(value);
  };

  let content = <RequestCode updateState={updateState} setEmail={setEmail} />;

  if (resetState === 'details') {
    content = (
      <RequestDetails
        updateState={updateState}
        email={email}
        forcedReset={forcedReset}
      />
    );
  }

  if (resetState === 'complete') {
    content = <CompleteRequest />;
  }

  useEffect(() => {
    if (modal) {
      //Remove modal flag if it was set
      handleModal();
    }
  }, [modal]);

  return (
    <div className="landing-page landing-page--centre">
      <div className="input-container">
        {content}
        <Link to="/" className="button button--tiny">
          {translate('return-to-login')}
        </Link>
      </div>
    </div>
  );
};

export default ResetPassword;
